import React from "react";
import { AdminSideMenu } from "./AdminMenu";

export const AdminDashboard = () => {
  return (
    <div className="flex h-screen">
      
      <AdminSideMenu />
      {/* Main Content */}
      <div className="flex-1 p-6 bg-gray-100 pt-16"> {/* Add padding-top for mobile */}
        <h1 className="text-2xl font-bold">Welcome to the Admin Dashboard</h1>
        <p className="mt-4 text-gray-700">
          This is where you can manage and perform other administrative
          tasks.
        </p>
      </div>
    </div>
  );
};
